(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function readConfig() {
    const node = $('#lp-cart-config');
    if (!node) return { drawer: false, toast: false, cartUrl: '/cart', checkoutUrl: '/checkout' };
    try {
      return JSON.parse(node.textContent);
    } catch {
      return { drawer: false, toast: false, cartUrl: '/cart', checkoutUrl: '/checkout' };
    }
  }

  function formatMoney(cents, currency) {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch {
      return `$${amount.toFixed(2)}`;
    }
  }

  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  function updateCartCounts(count) {
    const text = String(count ?? '');
    $$('#cart-notification-count, [data-lp-cart-count], [data-lp-cart-drawer-count]').forEach((el) => {
      el.textContent = text;
    });
    $$('[data-lp-cart-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  }

  function applySectionResponse(cartNotification, parsedState) {
    if (!parsedState?.sections) return;
    (cartNotification?.getSectionsToRender?.() || [{ id: 'mini-cart-drawer' }, { id: 'cart-notification-count' }]).forEach(
      (section) => {
        const html = parsedState.sections[section.id];
        if (!html) return;
        const target = document.getElementById(section.id);
        if (target) target.innerHTML = getSectionInnerHTML(html);
      }
    );
    if (typeof parsedState.item_count === 'number') updateCartCounts(parsedState.item_count);
  }

  let toastTimer;

  function hideAddedToast() {
    const root = $('#lp-cart-added-root');
    const toast = $('#lp-cart-added');
    if (!root || !toast) return;
    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');
    toast.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lp-cart-added-open');
    clearTimeout(toastTimer);
  }

  function getAddedLineItem(parsedState) {
    if (!parsedState || parsedState.status) return null;

    if (Array.isArray(parsedState.items) && parsedState.items.length) {
      return parsedState.items[parsedState.items.length - 1];
    }

    if (parsedState.product_title || parsedState.title) {
      return parsedState;
    }

    return null;
  }

  function showAddedToast(parsedState, currency) {
    if (!readConfig().toast) return;
    const root = $('#lp-cart-added-root');
    const toast = $('#lp-cart-added');
    const slot = $('[data-lp-cart-added-product]', toast);
    if (!root || !toast || !slot) return;

    const item = getAddedLineItem(parsedState);
    if (!item) return;

    const title = item.product_title || item.title || '';
    const variant = item.variant_title || '';
    const image = item.image || item.featured_image?.url || '';
    const price = item.final_price ?? item.price;
    const url = item.url || '#';

    const esc = (s) =>
      String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;');

    slot.innerHTML = `
      <a class="lp-cart-added__media" href="${esc(url)}">
        ${image ? `<img src="${esc(image)}" alt="" width="120" height="120" loading="lazy">` : ''}
      </a>
      <div class="lp-cart-added__info">
        <p class="lp-cart-added__price">${formatMoney(price, currency)}</p>
        <p class="lp-cart-added__title"><a href="${esc(url)}">${esc(title)}</a></p>
        ${
          variant && variant !== 'Default Title'
            ? `<p class="lp-cart-added__variant">${esc(variant)}</p>`
            : ''
        }
      </div>`;

    toast.removeAttribute('hidden');
    toast.setAttribute('aria-hidden', 'false');
    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lp-cart-added-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideAddedToast, 7000);
  }

  function setDrawerOpen(open) {
    if (!readConfig().drawer) return;
    const root = $('#lp-cart-drawer-root');
    const drawer = $('#mini-cart-drawer');
    if (!root || !drawer) return;

    root.classList.toggle('is-open', open);
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('lp-cart-drawer-open', open);
    document.body.classList.toggle('added__overlay', open);

    if (open) {
      drawer.classList.add('animate', 'active');
      $$('[data-lp-cart-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
    } else {
      drawer.classList.remove('active');
      $$('[data-lp-cart-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    }
  }

  async function refreshDrawerSections(cartNotification) {
    const ids = (cartNotification?.getSectionsToRender?.() || [{ id: 'mini-cart-drawer' }, { id: 'cart-notification-count' }])
      .map((s) => s.id)
      .join(',');
    const res = await fetch(`${window.location.pathname}?sections=${ids}`);
    const data = await res.json();
    applySectionResponse(cartNotification, { sections: data });
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      updateCartCounts(cart.item_count);
    } catch {
      /* ignore */
    }
  }

  function patchCartNotification(cartNotification, currency) {
    if (!cartNotification || cartNotification._lpCartPatched) return;

    const legacyClose =
      typeof cartNotification.close === 'function' ? cartNotification.close.bind(cartNotification) : null;

    cartNotification.renderContents = function (parsedState) {
      applySectionResponse(this, parsedState);
      if (typeof parsedState.item_count === 'number') updateCartCounts(parsedState.item_count);
      if (this._lpPendingAddToast) {
        showAddedToast(parsedState, currency);
        this._lpPendingAddToast = false;
        this.activeElement = null;
      }
    };

    if (legacyClose) {
      cartNotification.close = function () {
        legacyClose();
        setDrawerOpen(false);
      };
    }

    cartNotification._lpCartPatched = true;
  }

  function initCartPageSplit() {
    if (!document.body.classList.contains('lp-cart-split')) return;

    const main = $('#MainContent');
    if (!main || $('.lp-cart-split-band', main)) return;

    const itemsSec =
      $('.lp-cart-items-section', main) || main.querySelector('.shopify-section[id*="cart-items"]');
    const footerSec =
      $('.lp-cart-footer-section', main) || main.querySelector('.shopify-section[id*="cart-footer"]');
    if (!itemsSec || !footerSec) return;

    const itemsWrap = $('.cart_template_wrapper', itemsSec);
    const footerWrap = $('.cart_subtotal', footerSec);
    if (!itemsWrap || !footerWrap) return;

    const isBoxed =
      itemsWrap.classList.contains('container') || footerWrap.classList.contains('container');
    const innerClass = isBoxed ? 'container' : 'container-fluid';
    if (isBoxed) document.body.classList.add('lp-cart-split-boxed');

    itemsWrap.classList.remove('container', 'container-fluid', 'px-0');
    footerWrap.classList.remove('container', 'container-fluid', 'px-0');

    const band = document.createElement('div');
    band.className = 'lp-cart-split-band';
    const inner = document.createElement('div');
    inner.className = `lp-cart-split-inner ${innerClass}`;
    const grid = document.createElement('div');
    grid.className = 'lp-cart-split-grid';
    const mainCol = document.createElement('div');
    mainCol.className = 'lp-cart-split-main';
    const aside = document.createElement('div');
    aside.className = 'lp-cart-split-aside';

    itemsSec.parentNode.insertBefore(band, itemsSec);
    band.appendChild(inner);
    inner.appendChild(grid);
    grid.appendChild(mainCol);
    grid.appendChild(aside);
    mainCol.appendChild(itemsSec);
    aside.appendChild(footerSec);

    itemsSec.classList.add('lp-cart-split-section');
    footerSec.classList.add('lp-cart-split-section');
    setupCartSidebarCheckout(aside);
    document.body.classList.add('lp-cart-split-ready');
  }

  function refreshCartSidebarCheckout() {
    const aside = $('.lp-cart-split-aside');
    if (!aside) return;
    delete aside.dataset.lpSidebarCheckout;
    setupCartSidebarCheckout(aside);
  }

  function patchCartItemsForSidebar() {
    if (!document.body.classList.contains('lp-cart-split')) return;
    const run = () => {
      const CartItemsEl = customElements.get('cart-items');
      if (!CartItemsEl || CartItemsEl.prototype._lpSidebarCartPatched) return;
      const originalRender = CartItemsEl.prototype.renderContents;
      CartItemsEl.prototype.renderContents = function (parsedState) {
        originalRender.call(this, parsedState);
        refreshCartSidebarCheckout();
      };
      CartItemsEl.prototype._lpSidebarCartPatched = true;
    };
    if (customElements.get('cart-items')) run();
    else customElements.whenDefined('cart-items').then(run);
  }

  function setupCartSidebarCheckout(aside) {
    if (!aside || aside.dataset.lpSidebarCheckout === 'true') return;
    aside.dataset.lpSidebarCheckout = 'true';

    const checkoutBtn = $('.cart__checkout-button', aside);
    if (checkoutBtn) checkoutBtn.textContent = 'Checkout';

    const dynamic = $('.cart__dynamic-checkout-buttons', aside);
    if (!dynamic || dynamic.closest('.lp-cart-sidebar-payments')) return;

    const payments = document.createElement('div');
    payments.className = 'lp-cart-sidebar-payments';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'lp-cart-sidebar-payments__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = '+ View Express Checkout Options';

    const panel = document.createElement('div');
    panel.className = 'lp-cart-sidebar-payments__panel';
    panel.hidden = true;

    dynamic.parentNode.insertBefore(payments, dynamic);
    payments.appendChild(toggle);
    payments.appendChild(panel);
    panel.appendChild(dynamic);

    toggle.addEventListener('click', () => {
      const open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? '− Hide Payment Options' : '+ View More Payment Options';
    });
  }

  function init() {
    const config = readConfig();
    if (!config.drawer && !config.toast) return;

    const currency = $('#lp-runtime')?.dataset?.currency || 'USD';

    const runPatch = () => {
      $$('cart-notification').forEach((el) => patchCartNotification(el, currency));
    };

    if (customElements.get('cart-notification')) {
      runPatch();
    } else {
      customElements.whenDefined('cart-notification').then(runPatch);
    }

    const cartNotification = () => $('cart-notification');

    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-lp-cart-open]');
      if (openBtn && config.drawer) {
        e.preventDefault();
        hideAddedToast();
        setDrawerOpen(true);
        if (cartNotification()) {
          refreshDrawerSections(cartNotification()).catch(() => {});
        }
        return;
      }
      if (e.target.closest('[data-lp-cart-close]')) {
        setDrawerOpen(false);
        return;
      }
      if (e.target.closest('[data-lp-cart-added-close]')) hideAddedToast();
    });

    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape') {
        hideAddedToast();
        if (document.body.classList.contains('lp-cart-drawer-open')) setDrawerOpen(false);
      }
    });
  }

  function boot() {
    if (window.__lpCartBooted) return;
    window.__lpCartBooted = true;
    initCartPageSplit();
    patchCartItemsForSidebar();
    init();

    document.addEventListener('lp:cart:updated', (event) => {
      const parsedState = event.detail?.parsedState;
      if (!parsedState) return;
      updateCartCounts(parsedState.item_count);
      const cartNotification = $('cart-notification');
      if (cartNotification) applySectionResponse(cartNotification, parsedState);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
